import { css } from "@emotion/react";
import { omit } from "lodash/fp";
import { Fragment, useContext, useState } from "react";

import {
  Icon,
  Heading,
  useThemeProps,
  TypographyBlock,
  Section,
  PageGrid,
  PageGridItem,
  generateUniqueId,
} from "../../wsui/base";

import PostsModuleArchiveLink from "./PostsModuleArchiveLink.jsx";
import postsModuleContext from "./postsModuleContext";
import PostsModuleItem from "./PostsModuleItem.jsx";

export default function PostsModuleGridLayout(props) {
  props = useThemeProps({ props, name: "MunicipioPostsModuleGridLayout" });
  let {
    title,
    titleIcon,
    titleIconProps = { size: 8 },
    description,
    items,
    itemColspan = [4, 4, 12],
    headingVariant,
    rowGap = [8.75, 17.5],
    // archiveLink,
    gridMaxColumns,
    archiveLink,
    archiveLinkProps,
    headingId,
    align,
    ...restProps
  } = omit([], props);
  const contentAlign =
    align === "left" || align === "center" || align === "right"
      ? align
      : undefined;
  const archiveAlign =
    contentAlign === "right"
      ? "flex-end"
      : contentAlign === "center"
        ? "center"
        : "flex-start";

  let ownerState = useContext(postsModuleContext);
  let { itemVariant, visibleFields } = ownerState;

  itemColspan = gridMaxColumns
    ? [12 / gridMaxColumns, 12 / gridMaxColumns, 12]
    : itemColspan;

  let mediaColspan = gridMaxColumns === 1 ? 6 : undefined;

  const [defaltHeadingId] = useState(
    () => `module-heading-${generateUniqueId()}`,
  );
  headingId = headingId || defaltHeadingId;

  const MaybeSection = title ? Section : Fragment;

  return (
    <div
      css={css`
        height: 100%;
      `}
      {...restProps}
    >
      <div
        css={css`
          display: grid;
          grid-template-columns: 1fr max-content;
          align-items: start;
        `}
      >
        {title && (
          <Heading
            variant={headingVariant}
            marginAfter
            id={headingId}
            css={css`
              display: flex;
              gap: 0.5em;
              align-items: start;
            `}
          >
            {titleIcon && (
              <Icon
                name={titleIcon}
                css={css`
                  align-self: center;
                  flex: none;
                `}
                {...titleIconProps}
              />
            )}
            {title}
          </Heading>
        )}
        {archiveLink && (
          <PostsModuleArchiveLink
            align={archiveAlign}
            {...archiveLink}
            {...archiveLinkProps}
          />
        )}
      </div>
      {description && (
        <TypographyBlock marginAfter align="left">{description}</TypographyBlock>
      )}
      <MaybeSection>
        <PageGrid
          css={css`
            align-items: stretch;
          `}
          rowGap={rowGap}
        >
          {items.map((item, index) => (
            <PageGridItem key={index} colspan={itemColspan}>
              <PostsModuleItem
                item={item}
                visibleFields={visibleFields}
                variant={itemVariant}
                align={contentAlign}
                mirrored={gridMaxColumns === 1 && index % 2 === 1}
                mediaColspan={mediaColspan}
                css={css`
                  height: 100%;
                `}
              />
            </PageGridItem>
          ))}
        </PageGrid>
      </MaybeSection>
    </div>
  );
}
